// extracted by mini-css-extract-plugin
module.exports = {"main":"TextWithHeading_main__6rFsu","heading-subheading-container":"TextWithHeading_heading-subheading-container__c8GUs","body-container":"TextWithHeading_body-container__XaaT2"};